import React, { useEffect, useState, useContext } from "react";
import "../Notification/Notification.css";
import { Context } from "../../../../utils/context";

const Notification = (props) => {
  const { ReactLoader, setReactLoader, getData, signin } = useContext(Context);
  const [notifications, setNotification] = useState([]);
  const [activeTab, setActiveTab] = useState("All");

  const calculateHoursAgo = (updatedAt) => {
    const updatedTime = new Date(updatedAt);
    const currentTime = new Date();
    const timeDifferenceInMilliseconds = currentTime - updatedTime;
    const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);

    if (timeDifferenceInHours >= 24 * 7) {
      const weeks = Math.floor(timeDifferenceInHours / (24 * 7));
      return `${weeks} ${weeks === 1 ? "w" : "w"} ago`;
    } else if (timeDifferenceInHours >= 24) {
      const days = Math.floor(timeDifferenceInHours / 24);
      return `${days} ${days === 1 ? "d" : "d"} ago`;
    } else {
      const hours = Math.round(timeDifferenceInHours);
      return `${hours || 1} ${hours <= 1 ? "h" : "h"} ago`;
    }
  };

  // Groups items dynamically based on age matching the layout look
  const getTimeGroup = (updatedAt) => {
    const hours = (new Date() - new Date(updatedAt)) / (1000 * 60 * 60);
    if (hours < 24) return "Today";
    if (hours < 48) return "Yesterday";
    if (hours < 24 * 7) return "Last 7 days";
    if (hours < 24 * 15) return "Last 15 days";
    return "Older";
  };

  const getNotifications = async () => {
    const res = await getData(`/common/notifications`);
    if (res?.success) {
      setNotification(res?.data || []);
    }
  };

  useEffect(() => {
    if (signin) {
      getNotifications();
    }
  }, [props.show]);

  // --- Filtering & Grouping Logic ---
  // If your API provides a category property (e.g. type or category), use it here. 
  // Otherwise, default fallback filters matching the layout titles:
  const filteredNotifications = notifications.filter((item) => {
    if (activeTab === "All") return true;
    if (activeTab === "Job Recommendations") return item.message?.toLowerCase().includes("hiring") || item.message?.toLowerCase().includes("recommend");
    if (activeTab === "Recruiter Actions") return item.message?.toLowerCase().includes("search") || item.message?.toLowerCase().includes("contact");
    if (activeTab === "Application Status") return item.message?.toLowerCase().includes("interview") || item.message?.toLowerCase().includes("shortlist");
    return true;
  });

  // Group filtered notifications by timeline group
  const groups = ["Today", "Yesterday", "Last 7 days", "Last 15 days", "Older"];
  const groupedNotifications = groups.reduce((acc, group) => {
    const items = filteredNotifications.filter((n) => getTimeGroup(n.updatedAt) === group);
    if (items.length > 0) acc[group] = items;
    return acc;
  }, {});

  const tabs = ["All", "Job Recommendations", "Recruiter Actions", "Application Status"];

  return (
    <div className="notification-container">
      {/* Navigation Filter Tabs */}
      <div className="notification-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Grouped Notifications Loop */}
      <div className="notification-list-scroll">
        {Object.keys(groupedNotifications).length === 0 ? (
          <div className="no-notifications">No notifications found under this filter.</div>
        ) : (
          Object.entries(groupedNotifications).map(([groupName, items]) => (
            <div key={groupName} className="notification-timeline-group">
              <h4 className="timeline-heading">{groupName}</h4>
              
              {items.map((value, index) => (
                <div key={value.id || index} className="notification-row-item">
                  
                  {/* Left Unread Badge and Icon structure */}
                  <div className="badge-wrapper">
                    <span className="unread-dot"></span>
                    <div className="building-icon-box">
                      {/* Scalable Vector Graphics Building Icon */}
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="10" width="10" height="12" rx="2" ry="2"></rect>
                        <path d="M12 22V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v18"></path>
                        <path d="M6 14h.01"></path>
                        <path d="M6 18h.01"></path>
                        <path d="M16 6h.01"></path>
                        <path d="M16 10h.01"></path>
                        <path d="M16 14h.01"></path>
                        <path d="M16 18h.01"></path>
                      </svg>
                    </div>
                  </div>

                  {/* Main Message Context block */}
                  <div className="message-body">
                    <p className="message-text">
                      <strong className="company-bold">{value?.comapny_name}</strong>{" "}
                      {value?.message}
                      {value?.count !== 0 && value?.count !== undefined && (
                        <span className="count-badge"> : {value?.count}</span>
                      )}
                    </p>
                    <span className="category-subtext">
                      {value?.message?.toLowerCase().includes("hiring") ? "Job Recommendations" : "Recruiter Actions"}
                    </span>
                  </div>

                  {/* Right side static metadata timestamp */}
                  <div className="timestamp-aside">
                    {calculateHoursAgo(value?.updatedAt)}
                  </div>

                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Notification;